export enum InvoiceStatuses {
  Open = 'Open',
  PartiallyPaid = 'PartiallyPaid',
  Paid = 'Paid',
  Refunded = 'Refunded',
  Credit = 'Credit'
}

export type fileFormatType = 'Excel' | 'CSV';

export interface InvoiceItemType {
  invoiceStatus: keyof typeof InvoiceStatuses,
  invoiceNumber: string,
  invoiceDate: string,
  invoiceAmount: number
}
